import {useColorMode} from '@tempo/core';

export const useColorModeValue = <T>(lightValue: T, darkValue: T): T => {
	const {colorMode} = useColorMode();
	return colorMode === 'dark' ? darkValue : lightValue;
};
